import { NextPageContext, NextApiRequest, NextApiResponse } from 'next'
import * as config from '../config/default.json'
import { PrePopHotels } from './utils/typeahead-fetch-types'

declare global {
  interface Window {
    PCLN?: {
      HeaderClient?: {
        openModal: () => void
      }
    }
  }
}

export type BootstrapSETI = {
  [propName: string]: string
}

export type Referral = {
  id?: string
  sourceId?: string
  clickId?: string
  webEntryTime?: string
  expiration?: string
  trafficSource?: string
  trafficTier?: number
  [propName: string]: any
}
export type Webstats = {
  resolvedClientIP: string
  clientGUID: string
  clientRequestId: string
  firstTimeHere: boolean
  requestId: string
  requestTime: number
  startOfVisit: boolean
  userAgent: string
  visitId: string
  isMobile: boolean
  [propName: string]: any
}

export type SetiResponse = {
  resultCode: number
  resultMessage: string
  setiID: number
  setiTagName: string
  setiDesc: unknown | null
  setiTeamName: unknown | null
  setiVariantID: number
  setiVariantName: string
  variantList: unknown | null
  setiVariantDesc: unknown | null
  assignmentFound: boolean
  assignmentRecorded: boolean
  impressionRecorded: boolean
  elapsedTime: string
  exception: unknown | null
  experimentNotFound: boolean
  winningVariantFound: boolean
  offerRecorded: boolean
  experimentExpired: boolean
  experimentCreationQueued: boolean
  experimentNotNew: boolean
  usedConsistentHashing: boolean
  setiRunDateTime: string
}

type FullSeti = Array<SetiResponse> | []

export type TmsConfig = {
  productId: number
  pageType: string
  appCode: string
  mhe: string
  refId: string
  refClickId: string
  firstTimeHere: boolean
  startOfVisit: boolean
}

export type BootstrapData = {
  key: string
  referral: Referral
  webstats: Webstats
  appVersion: string
  baseUrl: string
  env: string
  pclnEnv: string
  isAndroid: boolean
  isCookieSetToHideAppBanner: boolean
  isIOS: boolean
  isMobile: boolean
  isTablet: boolean
  signInStatus: { signedIn: boolean; passiveSignIn: boolean }
  seti: BootstrapSETI
  tmsConfig: TmsConfig
  fullSETI: FullSeti
  customer: { firstName: string }
  locale: {
    localeCodeSource: string
    countryCode: string
    distanceFormat: unknown | null
    dateFormat: unknown | null
    countryName: string
    region: string
    city: string
    postalCode: string
    latitude: number
    longitude: number
    areaCode: number
    metroCode: number
    domainName: string
    orgName: string
    regionName: string
    timeZone: string
    ipAddr: string
    localeCode: string
    localeSupported: boolean
  }
  mostRecentBooking: any | null
  partner: Partner | null
  featureToggles?: FeatureToggles
  insideTrackTitle: string
  aceContent: any
  prePopData?: {
    hotels: Partial<PrePopHotels>
  }
}

export type CustomRequest = NextApiRequest & {
  cookies: {
    dmc?: string
  }
}

export type CustomResponse = NextApiResponse & {
  locals: {
    bootstrapData: BootstrapData
    bootstrapSETI: BootstrapSETI
    footerHTML?: string
    headerHTML?: string
    webstats: {
      clientGUID: string
    }
  }
}

export type CustomContext = NextPageContext & {
  req: CustomRequest
  res: CustomResponse
}

export type Partner = {
  plfCode: string
  globalPartnerCode: string
  config: {
    [propName: string]: any
  }
}

export type PageProps = {
  contentful: any
  headerHTML: string
  footerHTML: string
  bootstrapData: BootstrapData
  bootstrapSETI?: BootstrapSETI
  partner: Partner | null
}

export type LOCATION_SEARCH_TYPE = {
  address?: string | null
  addressLine1?: string
  airportCode?: string | number | null
  airportName?: string
  aliases?: string[]
  cityCode?: string
  cityName: string
  content?: string
  country: string
  countryName?: string
  countryCode: string
  debitCardFlag?: string
  displayName?: string
  entered: string
  fromSavedSearch?: boolean
  gmtOffset?: number
  highlightedName: string | null
  javaTimeZoneName?: string
  id: string
  isoCountryCode?: string
  isRecent?: boolean
  itemName: string
  lang?: string
  lat?: number
  lon?: number
  majorAirportFlag?: string
  opaqueParticipantFlag?: string
  partnerCode?: string
  partnerLocationCode?: string
  partnerName?: string
  partnerShortName?: string
  phoneNumber?: string
  poiCategoryName?: string | null
  poiCategoryTypeId?: number
  poiID?: number | null
  postalCode?: string
  proximity?: number
  provinceName?: string | null
  radius?: number
  rank?: number | null
  rccAirportFlag?: string
  rentalLocationsCount?: number
  savedTravelStartDate?: string | null
  savedTravelEndDate?: string | null
  score?: number | string
  seType?: string | null
  stateCode: string | null
  timeZoneId?: number
  type: 'AIRPORT' | 'CITY' | 'POI' | 'HOTEL' | 'LATLON' | 'PARTNER_LOC'
  zip?: string | null
  cityID: string
}

export type FeatureToggles = {
  [propName: string]: {
    [propName: string]: Record<string, unknown> | string | number | boolean
  }
}
export type EnumLiteralsOf<T extends Record<string, unknown>> = T[keyof T]

export const APP_ROUTES = {
  homepage1: '',
  homepage2: '/home',
  flights: '/flights',
  hotels: '/hotels',
  vacationpackages: '/vacationpackages'
} as const

export type APP_ROUTES_TYPE = EnumLiteralsOf<typeof APP_ROUTES>

export type Configuration = typeof config

export type QueryString = { [key: string]: string | string[] }
